import {
  QueryClient,
  useQuery,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
let csrf = "";
export const setCsrf = (value: string) => {
  csrf = value;
};
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: false, staleTime: 15000, refetchOnWindowFocus: true },
  },
});
export async function api<T = any>(
  path: string,
  options: RequestInit = {},
): Promise<T> {
  const headers = new Headers(options.headers);
  if (options.body && !(options.body instanceof FormData))
    headers.set("Content-Type", "application/json");
  if (csrf) headers.set("x-csrf-token", csrf);
  const response = await fetch("/api/v1" + path, {
    ...options,
    headers,
    credentials: "same-origin",
  });
  let data: any;
  try {
    data = await response.json();
  } catch {
    const error = new Error(
      `VIBE returned an unreadable response (HTTP ${response.status}). Refresh to check the latest state before trying again.`,
    ) as Error & { status: number };
    error.status = response.status;
    throw error;
  }
  if (!response.ok) {
    const error = new Error(typeof data?.error === "string" ? data.error : "Request failed") as Error & {
      status: number;
    };
    error.status = response.status;
    throw error;
  }
  return data;
}
export const get = <T = any>(path: string) => api<T>(path);
export const post = <T = any>(path: string, body: unknown = {}) =>
  api<T>(path, { method: "POST", body: JSON.stringify(body) });
export const patch = <T = any>(path: string, body: unknown) =>
  api<T>(path, { method: "PATCH", body: JSON.stringify(body) });
export function useData<T = any>(path: string, enabled = true) {
  return useQuery<T>({
    queryKey: [path],
    queryFn: () => get<T>(path),
    enabled,
  });
}
export function refresh() {
  return queryClient.invalidateQueries();
}
